<template>
  <div class="Login">
    <div
      class="Login-sidebar d-none d-md-block"
      :style="{ 'background-image': `url(${require(`@/assets/sidebar-background-${$site}.jpg`)})` }"
    >
      <div class="Login-sidebar-colorBlock">
        <div class="Login-sidebar-colorBlock-container">
          <div class="Login-logo"><img :src="require(`@/assets/logo-${$site}.png`)" :alt="`logo ${$site}`" /></div>
          <div class="Login-secondTitle mb-2">{{ $t('loginPage.secondTitle') }}</div>
          <div class="Login-title mb-4">{{ $t('loginPage.title') }}</div>
          <div class="Login-subtitle mb-12">{{ $t('loginPage.subtitle') }}</div>
          <v-row justify="center" class="flex-nowrap">
            <v-col class="Login-iconsList">
              <div v-for="n in 5" :key="n">
                <v-icon :color="([$const.sites.galileo, $const.sites.nikon, $const.sites['nikon-it']].includes($site)) ? 'white' : 'primary'" left>mdi-check-circle</v-icon>
              </div>
            </v-col>
            <v-col class="Login-argumentsList">
              <div v-for="n in 5" :key="n" class="Login-argument">{{ $t(`loginPage.argument.${n}`) }}</div>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <div class="Login-formContainer">
      <div class="Login-formContainer-card">
        <SignIn v-if="createAccountMode" @login="toLogin" /> <LogIn v-else :fromSign="fromSignIn" />
      </div>
    </div>
  </div>
</template>

<script>
import SignIn from '@/components/login/SignIn'
import LogIn from '@/components/login/LogIn'
export default {
  name: 'Login.vue',

  components: { LogIn, SignIn },

  data() {
    return {
      createAccountMode: this.$route.query.ecpId,
      fromSignIn: false
    }
  },

  methods: {
    toLogin(accountCreated) {
      this.createAccountMode = false
      this.fromSignIn = Boolean(accountCreated)
    }
  }
}
</script>

<style scoped lang="scss">
$size-padding-top: 200px;

.Login {
  display: flex;
  height: 100vh;
  text-align: center;
}

.Login-sidebar {
  position: relative;
  flex: 1;
  background-size: cover;
  background-position: center;
  color: white;
}

.Login-sidebar-colorBlock {
  width: 100%;
  height: 100%;
  padding: 0 42px;
  background-color: #323542e6;
}

.Login-sidebar-colorBlock-container {
  position: sticky;
  top: 200px;
  margin-bottom: 20px;
}

.Login-logo {
  position: fixed;
  top: 12px;
  left: 16px;
}

.Login-secondTitle {
  font-size: 0.9rem;
  font-weight: 700;
}

.Login-title {
  z-index: 100;
  font-size: 1.8rem;
  font-weight: 600;
}

.Login-subtitle {
  font-weight: 300;
}

.Login-argumentsList,
.Login-iconsList {
  flex-grow: 0;

  & > * {
    white-space: nowrap;
    margin-bottom: 1em;
  }
}

.Login-argumentsList {
  font-weight: 300;
  text-align: left;
}

.Login-formContainer {
  position: relative;
  flex: 1;
}

.Login-formContainer-card {
  position: sticky;
  top: 200px;
  max-width: 600px;
  width: 90%;
  margin: 36px auto 20px;
}
</style>

<style lang="scss">
.App-galileo .Login-sidebar-colorBlock {
  background-color: rgba(0, 163, 110, 0.85);
}

.App-nikon-it .Login-sidebar-colorBlock {
  background-color: rgba(0, 0, 0, 0.85);
}
</style>